import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RouteConstants } from '../../../constants/routes';

/**
 * Navigates to the home page and returns an observable that emits false.
 * This function is typically used in route resolvers to indicate that the navigation should not proceed further.
 * @param router - The Angular Router instance used to navigate to the home page.
 * @returns An observable that emits false, indicating that the navigation should not proceed further.
 */
export const navigateToHome = (router: Router): Observable<boolean> => {
    router.navigate([RouteConstants.Home.getHomeUrl()]);

    return of(false);
};
